import { ISwrConfiguration, useFetch } from 'lib/hooks';
import { useEffect } from 'react';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';
import { createUserInteraction } from './api';
import { IUserInteraction, UserInteraction } from './types';

export const useCreateUserInteraction = (
  interaction: UserInteraction,
  value?: string
) => {
  const [urlParams, setUrlParams] = useQueryParams({
    sId: NumberParam,
    se: StringParam,
    tId: NumberParam,
    te: StringParam,
  });

  useEffect(() => {
    if (urlParams.te || urlParams.se) {
      createUserInteraction('', {
        interaction: interaction,
        interactionValue: value,
        sId: urlParams.sId,
        se: urlParams.se,
        tId: urlParams.tId,
        te: urlParams.te,
      });
      setUrlParams(
        { sId: undefined, se: undefined, tId: undefined, te: undefined },
        'replaceIn'
      );
    }
  }, []);
};

export const useUserInteraction = (
  interaction: UserInteraction,
  options?: ISwrConfiguration
) =>
  useFetch<IUserInteraction[]>(
    `/tracking/interactions/${interaction}`,
    options
  );
